import { useApi } from '../composables/useApi.js';

const profileService = {
  getProfessionalProfile: async () => {
    return useApi().get('/profile/professional');
  },
  updateProfessionalProfile: async (profileData) => {
    return useApi().put('/profile/professional', profileData);
  },
  getGroupSubjects: async () => {
    return useApi().get('/profile/group-subjects');
  },
  updateGroupSubjects: async (groupSubjects) => {
    return useApi().post('/profile/group-subjects', { groupSubjects });
  },
  updateDeviceId: async (deviceId) => {
    return useApi().post('/profile/device-id', { deviceId });
  },
};

export default profileService;
